// @ts-strict-ignore
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { selectConfigurationVehicleNst } from 'src/app/store/common/common.selectors';

import { NbaParamResolver } from '../nba-param-resolver.interface';

import { NbaParamResolverId } from './nba-param-resolver-id.enum';

/**
 * Resolver for national sales type.
 * NST is optional and depends on the market / class. It is a "tool"
 * for markets to express or predefine specific standard-configurations for
 * baumusters that are differing from standard-configurations maintained centrally.
 *
 * @returns resolved nst or null (if vehicle or nst n/a).
 */
@Injectable()
export class NstResolver implements NbaParamResolver {
  public readonly identifier: string = NbaParamResolverId.Nst;

  public constructor(private readonly store: Store) {}

  public resolve$(): Observable<string | null> {
    return this.store.select(selectConfigurationVehicleNst);
  }
}
